import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=4585df33&scoped=true"
import script from "./Welcome.vue?vue&type=script&lang=ts"
export * from "./Welcome.vue?vue&type=script&lang=ts"
import style0 from "./Welcome.vue?vue&type=style&index=0&id=4585df33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4585df33",
  null
  
)

export default component.exports